import React from 'react';
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import EventMediaGallery from './EventMediaGallery';

const fallbackBackground =
  'linear-gradient(135deg, rgba(165,0,52,0.18) 0%, rgba(14,14,14,0.65) 100%)';

const EventCard = ({
  id,
  subtitle,
  title,
  description,
  image,
  actions = [],
  media = [],
  mediaFolder,
}) => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const reverse = !isMdDown && id % 2 === 0;

  return (
    <Box sx={{ mb: { xs: 6, md: 8 } }}>
      <Grid
        container
        spacing={{ xs: 3, md: 6 }}
        direction={reverse ? 'row-reverse' : 'row'}
        alignItems="stretch"
      >
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: 'relative',
              height: { xs: 240, sm: 300, md: 360 },
              borderRadius: 4,
              overflow: 'hidden',
              boxShadow: '0 22px 45px rgba(12, 12, 15, 0.25)',
              background: image ? undefined : fallbackBackground,
            }}
          >
            {image && (
              <Box
                component="img"
                src={image}
                alt={title}
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md={6} display="flex">
          <Card
            elevation={0}
            sx={{
              p: { xs: 3, md: 4 },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              borderRadius: 4,
              border: '1px solid rgba(15,15,20,0.08)',
              boxShadow: '0 18px 42px rgba(24, 24, 32, 0.12)',
            }}
          >
            <Stack spacing={2.5}>
              <Box>
                <Typography variant="overline" sx={{ letterSpacing: 2, color: 'primary.main' }}>
                  {subtitle}
                </Typography>
                <Typography variant="h5">{title}</Typography>
              </Box>

              <Typography variant="body1" color="text.secondary">
                {description}
              </Typography>

              {actions.length > 0 && (
                <Stack direction="row" spacing={1.5} flexWrap="wrap">
                  {actions.map((action, index) => (
                    <Button
                      key={index}
                      variant="contained"
                      color="primary"
                      href={action.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ mt: { xs: 1, md: 0 } }}
                    >
                      {action.text}
                    </Button>
                  ))}
                </Stack>
              )}

              <EventMediaGallery media={media} folder={mediaFolder} />
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EventCard;
